export const fieldsMock = [
  {
    id: 1,
    field_id: 1,
    custom_form_id: 1,
    visible: 'required',
    field_word_id: 'custom_first_name_label',
    table_word_id: 'custom_table_label',
    referenced_to: 'customers',
    order: 30,
    table_type_id: null,
    created_at: null,
    updated_at: '2024-09-02T16:42:24.000Z',
    field: {
      id: 1,
      slug: 'first_name',
      table_model: null,
      word_id: 'DfdBMDS90sda09dsa',
      referenced_to: '["customers"]',
      field_type_id: 1,
      table_type_id: null,
      created_at: null,
      updated_at: null,
      translation: {
        id: 1,
        description: 'First Name',
        word_id: 'DfdBMDS90sda09dsa',
        language_id: 1,
        site_type: 'ADMIN_BE',
        created_at: null,
        updated_at: '2024-08-29T11:49:58.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
      default_translation: {
        id: 1,
        description: 'First Name',
        word_id: 'DfdBMDS90sda09dsa',
        language_id: 1,
        site_type: 'ADMIN_BE',
        created_at: null,
        updated_at: '2024-08-29T11:49:58.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
    },
    ft: {
      id: 1,
      description: 'Text',
      input_type: 'text',
      input_class: 'form-control',
      parent_class: 'form-group form-floating',
      db_column_type: 'string',
      created_at: null,
      updated_at: null,
    },
    validation_rules: [
      {
        id: 1,
        description: 'String',
        slug: 'string',
        input: '',
        message: 'string_val',
        created_at: null,
        updated_at: null,
        form_field_id: 1,
        translation: {
          id: 8,
          description: 'The :attribute must be a string.',
          word_id: 'string_val',
          language_id: 1,
          site_type: 'ADMIN_BE',
          created_at: null,
          updated_at: null,
          record_id: null,
          module_id: null,
          locked: 0,
        },
      },
    ],
  },
  {
    id: 2,
    field_id: 2,
    custom_form_id: 1,
    visible: 'required',
    field_word_id: 'custom_last_name_label',
    table_word_id: 'custom_table_label',
    referenced_to: 'customers',
    order: 31,
    table_type_id: null,
    created_at: null,
    updated_at: '2024-09-02T16:42:24.000Z',
    field: {
      id: 2,
      slug: 'last_name',
      table_model: null,
      word_id: 'vvvvvvvvvvv',
      referenced_to: '["customers"]',
      field_type_id: 1,
      table_type_id: null,
      created_at: null,
      updated_at: null,
      translation: {
        id: 2,
        description: 'Last Name',
        word_id: 'vvvvvvvvvvv',
        language_id: 1,
        site_type: 'ADMIN_BE',
        created_at: null,
        updated_at: null,
        record_id: null,
        module_id: null,
        locked: 0,
      },
      default_translation: {
        id: 2,
        description: 'Last Name',
        word_id: 'vvvvvvvvvvv',
        language_id: 1,
        site_type: 'ADMIN_BE',
        created_at: null,
        updated_at: null,
        record_id: null,
        module_id: null,
        locked: 0,
      },
    },
    ft: {
      id: 1,
      description: 'Text',
      input_type: 'text',
      input_class: 'form-control',
      parent_class: 'form-group form-floating',
      db_column_type: 'string',
      created_at: null,
      updated_at: null,
    },
    validation_rules: [
      {
        id: 1,
        description: 'String',
        slug: 'string',
        input: '',
        message: 'string_val',
        created_at: null,
        updated_at: null,
        form_field_id: 2,
        translation: {
          id: 8,
          description: 'The :attribute must be a string.',
          word_id: 'string_val',
          language_id: 1,
          site_type: 'ADMIN_BE',
          created_at: null,
          updated_at: null,
          record_id: null,
          module_id: null,
          locked: 0,
        },
      },
    ],
  },
  {
    id: 3,
    field_id: 3,
    custom_form_id: 1,
    visible: 'required',
    field_word_id: 'custom_email_label',
    table_word_id: 'custom_table_label',
    referenced_to: 'customers',
    order: 32,
    table_type_id: null,
    created_at: null,
    updated_at: '2024-09-02T16:42:24.000Z',
    field: {
      id: 3,
      slug: 'email',
      table_model: null,
      word_id: 'PlpkdsiW2dsasjdsa',
      referenced_to: '["customers"]',
      field_type_id: 2,
      table_type_id: null,
      created_at: null,
      updated_at: null,
      translation: {
        id: 3,
        description: 'Email',
        word_id: 'PlpkdsiW2dsasjdsa',
        language_id: 1,
        site_type: 'ADMIN_BE',
        created_at: null,
        updated_at: null,
        record_id: null,
        module_id: null,
        locked: 0,
      },
      default_translation: {
        id: 3,
        description: 'Email',
        word_id: 'PlpkdsiW2dsasjdsa',
        language_id: 1,
        site_type: 'ADMIN_BE',
        created_at: null,
        updated_at: null,
        record_id: null,
        module_id: null,
        locked: 0,
      },
    },
    ft: {
      id: 2,
      description: 'Email',
      input_type: 'email',
      input_class: 'form-control',
      parent_class: 'form-group form-floating',
      db_column_type: 'string',
      created_at: null,
      updated_at: null,
    },
    validation_rules: [
      {
        id: 3,
        description: 'Unique',
        slug: 'unique',
        input: '',
        message: 'unique_val',
        created_at: null,
        updated_at: null,
        form_field_id: 3,
        translation: {
          id: 10,
          description:
            'The inserted :attribute already exists in out database.',
          word_id: 'unique_val',
          language_id: 1,
          site_type: 'ADMIN_BE',
          created_at: null,
          updated_at: null,
          record_id: null,
          module_id: null,
          locked: 0,
        },
      },
      {
        id: 5,
        description: 'Email',
        slug: 'email',
        input: '',
        message: 'email_val',
        created_at: null,
        updated_at: null,
        form_field_id: 3,
        translation: {
          id: 11,
          description: 'The :attribute must be an valid email.',
          word_id: 'email_val',
          language_id: 1,
          site_type: 'ADMIN_BE',
          created_at: null,
          updated_at: null,
          record_id: null,
          module_id: null,
          locked: 0,
        },
      },
    ],
  },
  {
    id: 5,
    field_id: 5,
    custom_form_id: 1,
    visible: 'optional',
    field_word_id: '8bN8SPJZI1725302536167',
    table_word_id: '',
    referenced_to: 'customers',
    order: 33,
    table_type_id: null,
    created_at: '2024-09-02T16:42:16.000Z',
    updated_at: '2024-09-02T16:42:33.000Z',
    field: {
      id: 5,
      slug: 'phone',
      table_model: null,
      word_id: 'jFUnt0xh71725302345189',
      referenced_to: '["customers"]',
      field_type_id: 1,
      table_type_id: null,
      created_at: '2024-09-02T16:39:05.000Z',
      updated_at: '2024-09-02T16:39:05.000Z',
      translation: {
        id: 1131,
        description: 'Phone',
        word_id: 'jFUnt0xh71725302345189',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:39:05.000Z',
        updated_at: '2024-09-02T16:39:05.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
      default_translation: {
        id: 1131,
        description: 'Phone',
        word_id: 'jFUnt0xh71725302345189',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:39:05.000Z',
        updated_at: '2024-09-02T16:39:05.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
    },
    ft: {
      id: 1,
      description: 'Text',
      input_type: 'text',
      input_class: 'form-control',
      parent_class: 'form-group form-floating',
      db_column_type: 'string',
      created_at: null,
      updated_at: null,
    },
    validation_rules: [],
  },
  {
    id: 6,
    field_id: 6,
    custom_form_id: 1,
    visible: 'required',
    field_word_id: 'xLaboVOxs1725302536170',
    table_word_id: '',
    referenced_to: 'customers',
    order: 34,
    table_type_id: null,
    created_at: '2024-09-02T16:42:16.000Z',
    updated_at: '2024-09-02T16:42:33.000Z',
    field: {
      id: 6,
      slug: 'street',
      table_model: null,
      word_id: 'Yv4CNznx51725302357437',
      referenced_to: '["customers"]',
      field_type_id: 1,
      table_type_id: null,
      created_at: '2024-09-02T16:39:17.000Z',
      updated_at: '2024-09-02T16:39:17.000Z',
      translation: {
        id: 1132,
        description: 'Street',
        word_id: 'Yv4CNznx51725302357437',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:39:17.000Z',
        updated_at: '2024-09-02T16:39:17.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
      default_translation: {
        id: 1132,
        description: 'Street',
        word_id: 'Yv4CNznx51725302357437',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:39:17.000Z',
        updated_at: '2024-09-02T16:39:17.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
    },
    ft: {
      id: 1,
      description: 'Text',
      input_type: 'text',
      input_class: 'form-control',
      parent_class: 'form-group form-floating',
      db_column_type: 'string',
      created_at: null,
      updated_at: null,
    },
    validation_rules: [],
  },
  {
    id: 7,
    field_id: 7,
    custom_form_id: 1,
    visible: 'required',
    field_word_id: '1wBPteRo21725302536172',
    table_word_id: '',
    referenced_to: 'customers',
    order: 35,
    table_type_id: null,
    created_at: '2024-09-02T16:42:16.000Z',
    updated_at: '2024-09-02T16:42:33.000Z',
    field: {
      id: 7,
      slug: 'city',
      table_model: null,
      word_id: '57VeiXWkN1725302377018',
      referenced_to: '["customers"]',
      field_type_id: 1,
      table_type_id: null,
      created_at: '2024-09-02T16:39:37.000Z',
      updated_at: '2024-09-02T16:39:37.000Z',
      translation: {
        id: 1133,
        description: 'City',
        word_id: '57VeiXWkN1725302377018',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:39:37.000Z',
        updated_at: '2024-09-02T16:39:37.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
      default_translation: {
        id: 1133,
        description: 'City',
        word_id: '57VeiXWkN1725302377018',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:39:37.000Z',
        updated_at: '2024-09-02T16:39:37.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
    },
    ft: {
      id: 1,
      description: 'Text',
      input_type: 'text',
      input_class: 'form-control',
      parent_class: 'form-group form-floating',
      db_column_type: 'string',
      created_at: null,
      updated_at: null,
    },
    validation_rules: [],
  },
  {
    id: 8,
    field_id: 8,
    custom_form_id: 1,
    visible: 'required',
    field_word_id: 'zbdkWVYFL1725302536174',
    table_word_id: '',
    referenced_to: 'customers',
    order: 36,
    table_type_id: null,
    created_at: '2024-09-02T16:42:16.000Z',
    updated_at: '2024-09-02T16:42:33.000Z',
    field: {
      id: 8,
      slug: 'state',
      table_model: null,
      word_id: 'UmDlWG3wJ1725302391587',
      referenced_to: '["customers"]',
      field_type_id: 1,
      table_type_id: null,
      created_at: '2024-09-02T16:39:51.000Z',
      updated_at: '2024-09-02T16:39:51.000Z',
      translation: {
        id: 1134,
        description: 'State',
        word_id: 'UmDlWG3wJ1725302391587',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:39:51.000Z',
        updated_at: '2024-09-02T16:39:51.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
      default_translation: {
        id: 1134,
        description: 'State',
        word_id: 'UmDlWG3wJ1725302391587',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:39:51.000Z',
        updated_at: '2024-09-02T16:39:51.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
    },
    ft: {
      id: 1,
      description: 'Text',
      input_type: 'text',
      input_class: 'form-control',
      parent_class: 'form-group form-floating',
      db_column_type: 'string',
      created_at: null,
      updated_at: null,
    },
    validation_rules: [],
  },
  {
    id: 9,
    field_id: 9,
    custom_form_id: 1,
    visible: 'required',
    field_word_id: 'WQiS47tda1725302536176',
    table_word_id: '',
    referenced_to: 'customers',
    order: 37,
    table_type_id: null,
    created_at: '2024-09-02T16:42:16.000Z',
    updated_at: '2024-09-02T16:42:33.000Z',
    field: {
      id: 9,
      slug: 'zip',
      table_model: null,
      word_id: 'zga7Go8Gl1725302404706',
      referenced_to: '["customers"]',
      field_type_id: 1,
      table_type_id: null,
      created_at: '2024-09-02T16:40:04.000Z',
      updated_at: '2024-09-02T16:40:04.000Z',
      translation: {
        id: 1135,
        description: 'zip',
        word_id: 'zga7Go8Gl1725302404706',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:40:04.000Z',
        updated_at: '2024-09-02T16:40:04.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
      default_translation: {
        id: 1135,
        description: 'zip',
        word_id: 'zga7Go8Gl1725302404706',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:40:04.000Z',
        updated_at: '2024-09-02T16:40:04.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
    },
    ft: {
      id: 1,
      description: 'Text',
      input_type: 'text',
      input_class: 'form-control',
      parent_class: 'form-group form-floating',
      db_column_type: 'string',
      created_at: null,
      updated_at: null,
    },
    validation_rules: [],
  },
  {
    id: 10,
    field_id: 10,
    custom_form_id: 1,
    visible: 'required',
    field_word_id: 'Jtp5A0OhK1725302536178',
    table_word_id: '',
    referenced_to: 'customers',
    order: 38,
    table_type_id: null,
    created_at: '2024-09-02T16:42:16.000Z',
    updated_at: '2024-09-02T16:42:33.000Z',
    field: {
      id: 10,
      slug: 'country',
      table_model: null,
      word_id: 'vZDvy5bCR1725302415706',
      referenced_to: '["customers"]',
      field_type_id: 1,
      table_type_id: null,
      created_at: '2024-09-02T16:40:15.000Z',
      updated_at: '2024-09-02T16:40:15.000Z',
      translation: {
        id: 1136,
        description: 'Country',
        word_id: 'vZDvy5bCR1725302415706',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:40:15.000Z',
        updated_at: '2024-09-02T16:40:15.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
      default_translation: {
        id: 1136,
        description: 'Country',
        word_id: 'vZDvy5bCR1725302415706',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:40:15.000Z',
        updated_at: '2024-09-02T16:40:15.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
    },
    ft: {
      id: 1,
      description: 'Text',
      input_type: 'text',
      input_class: 'form-control',
      parent_class: 'form-group form-floating',
      db_column_type: 'string',
      created_at: null,
      updated_at: null,
    },
    validation_rules: [],
  },
  {
    id: 11,
    field_id: 11,
    custom_form_id: 1,
    visible: 'optional',
    field_word_id: 'Z9d7I48k21725302536180',
    table_word_id: '',
    referenced_to: 'customers',
    order: 39,
    table_type_id: null,
    created_at: '2024-09-02T16:42:16.000Z',
    updated_at: '2024-09-02T16:42:33.000Z',
    field: {
      id: 11,
      slug: 'company',
      table_model: null,
      word_id: 'lCcGMlfs91725302434829',
      referenced_to: '["customers"]',
      field_type_id: 1,
      table_type_id: null,
      created_at: '2024-09-02T16:40:34.000Z',
      updated_at: '2024-09-02T16:40:34.000Z',
      translation: {
        id: 1137,
        description: 'Company',
        word_id: 'lCcGMlfs91725302434829',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:40:34.000Z',
        updated_at: '2024-09-02T16:40:34.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
      default_translation: {
        id: 1137,
        description: 'Company',
        word_id: 'lCcGMlfs91725302434829',
        language_id: 1,
        site_type: null,
        created_at: '2024-09-02T16:40:34.000Z',
        updated_at: '2024-09-02T16:40:34.000Z',
        record_id: null,
        module_id: null,
        locked: 0,
      },
    },
    ft: {
      id: 1,
      description: 'Text',
      input_type: 'text',
      input_class: 'form-control',
      parent_class: 'form-group form-floating',
      db_column_type: 'string',
      created_at: null,
      updated_at: null,
    },
    validation_rules: [],
  },
  {
    id: 4,
    field_id: 4,
    custom_form_id: 1,
    visible: 'required',
    field_word_id: 'custom_password_label',
    table_word_id: 'custom_table_label',
    referenced_to: 'customers',
    order: 40,
    table_type_id: null,
    created_at: null,
    updated_at: '2024-09-02T16:42:33.000Z',
    field: {
      id: 4,
      slug: 'password',
      table_model: null,
      word_id: 'asdbv943jndfNadosadjoasod',
      referenced_to: '["customers"]',
      field_type_id: 3,
      table_type_id: null,
      created_at: null,
      updated_at: null,
      translation: {
        id: 7,
        description: 'Password',
        word_id: 'asdbv943jndfNadosadjoasod',
        language_id: 1,
        site_type: 'ADMIN_BE',
        created_at: null,
        updated_at: null,
        record_id: null,
        module_id: null,
        locked: 0,
      },
      default_translation: {
        id: 7,
        description: 'Password',
        word_id: 'asdbv943jndfNadosadjoasod',
        language_id: 1,
        site_type: 'ADMIN_BE',
        created_at: null,
        updated_at: null,
        record_id: null,
        module_id: null,
        locked: 0,
      },
    },
    ft: {
      id: 3,
      description: 'Password',
      input_type: 'password',
      input_class: 'form-control',
      parent_class: 'form-group form-floating',
      db_column_type: 'string',
      created_at: null,
      updated_at: null,
    },
    validation_rules: [
      {
        id: 6,
        description: 'Min',
        slug: 'min',
        input: 'min',
        message: 'min_val',
        created_at: null,
        updated_at: null,
        form_field_id: 4,
        translation: {
          id: 13,
          description: 'The :attribute must contain at least :min characters.',
          word_id: 'min_val',
          language_id: 1,
          site_type: 'ADMIN_BE',
          created_at: null,
          updated_at: '2024-08-29T11:43:25.000Z',
          record_id: null,
          module_id: null,
          locked: 0,
        },
      },
      {
        id: 18,
        description: 'Confirmed',
        slug: 'confirmed',
        input: '',
        message: 'confirmed_val',
        created_at: null,
        updated_at: null,
        form_field_id: 4,
        translation: {
          id: 25,
          description: 'The :attribute does not match.',
          word_id: 'confirmed_val',
          language_id: 1,
          site_type: 'ADMIN_BE',
          created_at: null,
          updated_at: null,
          record_id: null,
          module_id: null,
          locked: 0,
        },
      },
      {
        id: 14,
        description: 'Must contain at least one lowercase letter',
        slug: 'regex:/[a-z]/',
        input: '',
        message: 'lowercase_val',
        created_at: null,
        updated_at: null,
        form_field_id: 4,
        translation: {
          id: 21,
          description:
            'The :attribute must contain at least one lowercase letter.',
          word_id: 'lowercase_val',
          language_id: 1,
          site_type: 'ADMIN_BE',
          created_at: null,
          updated_at: null,
          record_id: null,
          module_id: null,
          locked: 0,
        },
      },
      {
        id: 15,
        description: 'Must contain at least one uppercase letter',
        slug: 'regex:/[A-Z]/',
        input: '',
        message: 'uppercase_val',
        created_at: null,
        updated_at: null,
        form_field_id: 4,
        translation: {
          id: 22,
          description:
            'The :attribute must contain at least one uppercase letter.',
          word_id: 'uppercase_val',
          language_id: 1,
          site_type: 'ADMIN_BE',
          created_at: null,
          updated_at: null,
          record_id: null,
          module_id: null,
          locked: 0,
        },
      },
      {
        id: 16,
        description: 'Must contain at least one digit',
        slug: 'regex:/[0-9]/',
        input: '',
        message: 'digit_val',
        created_at: null,
        updated_at: null,
        form_field_id: 4,
        translation: {
          id: 23,
          description: 'The :attribute must contain at least one digit.',
          word_id: 'digit_val',
          language_id: 1,
          site_type: 'ADMIN_BE',
          created_at: null,
          updated_at: null,
          record_id: null,
          module_id: null,
          locked: 0,
        },
      },
      {
        id: 17,
        description: 'Must contain a special character',
        slug: 'regex:/[^A-Za-z0-9]/',
        input: '',
        message: 'special_char_val',
        created_at: null,
        updated_at: null,
        form_field_id: 4,
        translation: {
          id: 24,
          description:
            'The :attribute must contain at least one special charachter.',
          word_id: 'special_char_val',
          language_id: 1,
          site_type: 'ADMIN_BE',
          created_at: null,
          updated_at: null,
          record_id: null,
          module_id: null,
          locked: 0,
        },
      },
    ],
  },
];

export const accountFieldsMock = [
  { id: 'first_name', label: 'First Name', required: true },
  { id: 'last_name', label: 'Last Name', required: true },
  { id: 'email', label: 'Email', required: true },
  { id: 'phone', label: 'Phone', required: false },
  { id: 'street', label: 'Street', required: false },
  { id: 'city', label: 'City', required: false },
  { id: 'state', label: 'State', required: false },
  { id: 'zip', label: 'Zip', required: false },
  { id: 'country', label: 'Country', required: false },
  { id: 'company', label: 'Company', required: false },
];

export const tabsMock = [
  { id: 'account', label: 'Account Details' },
  { id: 'password', label: 'Password' },
];

export const rfqMock = [
  {
    id: 1,
    name: 'XM-A2A3-0404D',
    desc: 'Steel module',
    price: 226,
    date: '2025-11-07',
    status: 'Approved',
  },
  {
    id: 2,
    name: 'XM-B4C5-0909F',
    desc: 'Aluminum base',
    price: 124.5,
    date: '2025-10-30',
    status: 'Pending',
  },
  {
    id: 3,
    name: 'XM-C3D2-0707E',
    desc: 'Plastic frame',
    price: 90,
    date: '2025-09-15',
    status: 'Rejected',
  },
  {
    id: 4,
    name: 'XM-B4C5-0909F',
    desc: 'Aluminum base',
    price: 124.5,
    date: '2025-10-30',
    status: 'Pending',
  },
  {
    id: 5,
    name: 'XM-C3D2-0707E',
    desc: 'Plastic frame',
    price: 90,
    date: '2025-09-15',
    status: 'Rejected',
  },
  {
    id: 6,
    name: 'XM-B4C5-0909F',
    desc: 'Aluminum base',
    price: 124.5,
    date: '2025-10-30',
    status: 'Pending',
  },
  {
    id: 7,
    name: 'XM-C3D2-0707E',
    desc: 'Plastic frame',
    price: 90,
    date: '2025-09-15',
    status: 'Rejected',
  },
  {
    id: 8,
    name: 'XM-C3D2-0707E',
    desc: 'Plastic frame',
    price: 90,
    date: '2025-09-15',
    status: 'Rejected',
  },
];
